import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { MatSelect } from "@angular/material/select";
import { ListItem } from "src/app/models/listItem";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-dropdown',
    templateUrl: './dropdown.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropDownComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public data: any[];
    @Input() public keyText: string;
    @Input() public keyValue: string;
    @Input() public isListItemArray: boolean;
    @Input() public labelName: string;
    @Input() public hideLabel: boolean;
    @Input() public autoTranslate: boolean = true;

    @Output() public emitSelected: EventEmitter<any> = new EventEmitter();

    public list: ListItem[];

    constructor(
        public helperService: HelperService,
        private eleRef: ElementRef,
		private renderer: Renderer2,
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isListItemArray) {
            this.list = this.helperService.convertModelToList(this.data, "text", "value");;
        } else {
            this.list = this.helperService.convertModelToList(this.data, this.keyText, this.keyValue);
        }
    }

    public onChange(event: MatOptionSelectionChange): void {
        if (event.isUserInput) {
            this.emitSelected.emit(event.source.value);
        }
    }

    public onOpened(): void {
        this.eleRef.nativeElement.querySelectorAll('div').forEach((child: HTMLElement) => {
            this.renderer.removeAttribute(child, 'app-disabled');
            this.renderer.removeAttribute(child, 'disabled');
        });

        this.eleRef.nativeElement.querySelectorAll('mat-option').forEach((child: HTMLElement) => {
            this.renderer.removeAttribute(child, 'app-disabled');
            this.renderer.removeAttribute(child, 'disabled');
        });

        this.eleRef.nativeElement.querySelectorAll('span').forEach((child: HTMLElement) => {
            this.renderer.removeAttribute(child, 'app-disabled');
            this.renderer.removeAttribute(child, 'disabled');
        });
    }
}
